export default class BrowserDetect {
    name = '';
    version = 0;
    system = '';

    constructor(userAgent) {
        if (!userAgent) {
            userAgent = navigator.userAgent;
        }

        this.parse(userAgent)
    }

    parse(userAgent) {
        let m;

        if(m = userAgent.match(/(Edg|EdgA|EdgiOS|Edge)\/([\d\.]+)/)) {
            this.name = 'Edge';
            this.version = parseInt(m[2].split('.')[0]);
        } else if(m = userAgent.match(/YaBrowser\/([\d\.]+)/)) {
            this.name = 'Yandex';
            this.version = parseInt(m[1].split('.')[0]);
        } else if(m = userAgent.match(/OPR\/([\d\.]+)/)) {
            this.name = 'Opera';
            this.version = parseInt(m[1].split('.')[0]);
        } else if(m = userAgent.match(/Opera\/([\d\.]+)/)) {
            this.name = 'Opera';
            this.version = parseInt(m[1].split('.')[0]);
        } else if(m = userAgent.match(/Chrome\/([\d\.]+)/)) {
            this.name = 'Chrome';
            this.version = parseInt(m[1].split('.')[0]);
        } else if(m = userAgent.match(/Safari\/([\d\.]+)/)) {
            this.name = 'Safari';
            this.version = parseInt(m[1].split('.')[0]);
        } else if(m = userAgent.match(/Firefox\/([\d\.]+)/)) {
            this.name = 'Firefox';
            this.version = parseInt(m[1].split('.')[0]);
        } else if(m = userAgent.match(/MSIE ([\d\.]+)/)) {
            this.name = 'Internet Explorer';
            this.version = parseInt(m[1].split('.')[0]);
        } else if(userAgent.match(/Trident\//) && (m = userAgent.match(/rv:([\d.]+)/))) {
            this.name = 'Internet Explorer';
            this.version = parseInt(m[1].split('.')[0]);
        }

        if(userAgent.match(/(Windows Phone|WPDesktop)/)) {
            this.system = 'Windows Phone';
        } else if(userAgent.indexOf("Windows") > -1) {
            this.system = 'Windows';
        } else if(userAgent.indexOf("iPad") > -1) {
            this.system = 'iOS';
        } else if(userAgent.indexOf("iPod") > -1) {
            this.system = 'iOS';
        } else if(userAgent.indexOf("iPhone") > -1) {
            this.system = 'iOS';
        } else if(userAgent.indexOf("Mac OS X") > -1) {
            this.system = 'Mac OS X';
        } else if(userAgent.indexOf("Android") > -1) {
            this.system = 'Android';
        } else if(userAgent.indexOf("Linux") > -1) {
            this.system = 'Linux';
        }
    }

	isEdge() {
		return this.name === 'Edge' ? this.version : false;
	}
	isYandex() {
		return this.name === 'Yandex' ? this.version : false;
	}
	isOpera() {
		return this.name === 'Opera' ? this.version : false;
	}
	isChrome() {
		return this.name === 'Chrome' ? this.version : false;
	}
	isSafari() {
		return this.name === 'Safari' ? this.version : false;
	}
	isFirefox() {
		return this.name === 'Firefox' ? this.version : false;
	}
	isExplorer() {
		return this.name === 'Internet Explorer' ? this.version : false;
	}

	isMacOS() {
		return this.system === 'Mac OS X';
	}
	isIOS() {
		return this.system === 'iOS';
	}
	isAndroid() {
		return this.system === 'Android';
	}
	isWindows() {
		return this.system === 'Windows';
	}
	isLinux() {
		return this.system === 'Linux';
	}
	isWindowsPhone() {
		return this.system === 'Windows Phone';
	}
	isMobile() {
		return this.isIOS() || this.isAndroid() || this.isWindowsPhone();
	}
	isDesktop() {
		return !this.isMobile();
	};
}

export const currentBrowser = new BrowserDetect();
